module.exports = __webpack_public_path__ + "img/empty_ico_coupon.cd537b44.png";